module.exports = __webpack_public_path__ + "Nikhil-f1abfa8e.png";